<ng-container *ngFor="let opportunity of opportunities">
  <div class="opportunity">

    <spark-summary-card
      data-testid="opportunity-card"
      [isClickable]="true"
      (onClick)="onClick(opportunity)"
      [link]="isNavigatable ? ['/Opportunities', opportunity.id] : []">

      <summary-card-icon>
        <lds-icon  [name]="opportunity.opportunityType | opportunityIcon" size="md" appearance="inherit"></lds-icon>
      </summary-card-icon>

      <!-- card / content -->
      <summary-card-header>
        <div class="row align-items-center">
          <div class="col-7 col-md-4">

            <div class="summary-card__title truncate">{{ opportunity.name }}</div>
            <div class="truncate">{{ opportunity.borrowers }}</div>

          </div>

          <!-- opp. / tags -->
          <div class="col-12 col-md-4">
            <div class="entity-tags" *ngIf="opportunity.tags?.length">
              <span class="entity-tag-pill" *ngFor="let tag of opportunity.tags">
                {{ tag.tagName }}
              </span>
            </div>
          </div>

          <div class="col-auto col-md-2 order-last">

            <!-- opp. / date -->
            <div>
              <lds-icon
                name="calendar"
                size="xs"
                appearance="inherit">
              </lds-icon>
              <span class="ml-xs">
                {{ opportunity.createdDate | date: 'dd/MM/yyyy' }}
              </span>
            </div>

            <!-- opp. / assigned -->
            <!-- TODO: update icon ref. dep. LDS [future release] -->
            <div class="truncate">
              <lds-icon
                name="user"
                size="xs"
                appearance="inherit"
                *ngIf="opportunity.portfolio | adviserName:users">
              </lds-icon>
              <span class="ml-xs">
                {{ opportunity.portfolio | adviserName:users }}
              </span>
            </div>

          </div>
          <div class="col-auto col-md-2 ml-auto order-md-last">

            <div class="summary-card__highlight text-right">{{ (opportunity.loanAmount ?? opportunity.estimatedAmount) | currencyWithoutCents }}</div>
            <div class=" text-right">{{ opportunity.status }}</div>

          </div>
        </div>
      </summary-card-header>

      <!-- card / action -->
      <summary-card-actions>

        <lds-icon
          summary-card-action
          name="arrow-right"
          appearance="inherit">
        </lds-icon>

      </summary-card-actions>

    </spark-summary-card>

  </div>
</ng-container>
